export default "__VITE_ASSET__BlxcGWMh__"